import { Screen } from '~/screens/StressAssessments/new';

export const StressAssessmentsNew: React.FC = () => <Screen />;
